import { ACHFundTransactionResponse } from 'vopay';
import { useEffect, FC, useState } from 'react';
import useFetchACHFundTransaction from '@/hooks/useApi/useFetchACHFundTransaction';
import AchFundingTransactionInfo from './ACHFundingTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type AchFundingTransactionProps = {
  TransactionID: string;
  Notes: string;
  isParent?: boolean;
  jwt: string;
};

const AchFundingTransactionContainer: FC<AchFundingTransactionProps> = ({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
}) => {
  const { userSettings } = useUserSettingsProvider();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<ACHFundTransactionResponse>();
  const [achFundTransaction, getAchFundTransaction, resetTransactionsId] = useFetchACHFundTransaction({ bearer: jwt });

  useEffect(() => {
    getAchFundTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (achFundTransaction) {
      setTransaction(achFundTransaction);
    }
  }, [achFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  return (
    <div>
      {transaction && (
        <AchFundingTransactionInfo transaction={transaction} Notes={Notes} isParent={isParent} jwt={jwt} />
      )}
    </div>
  );
};

export default AchFundingTransactionContainer;
